import { render, staticRenderFns } from "./PortalDoClienteUserManage.vue?vue&type=template&id=49ed8d04"
import script from "./PortalDoClienteUserManage.vue?vue&type=script&lang=js"
export * from "./PortalDoClienteUserManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports